import React, { useState, useEffect } from 'react';
import './GlobalAlertModal.css';

export default function GlobalAlertModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleAlert = (e) => {
      setMessage(e.detail?.message || '');
      setIsOpen(true);
    };

    // Override the native window.alert globally
    window.alert = (msg) => {
      window.dispatchEvent(new CustomEvent('show-global-alert', { detail: { message: String(msg) } }));
    };

    window.addEventListener('show-global-alert', handleAlert);

    return () => {
      window.removeEventListener('show-global-alert', handleAlert);
    };
  }, []);

  if (!isOpen) return null;

  const isSuccess = message.toLowerCase().includes('success');
  const icon = isSuccess ? '✅' : '⚠️';
  const title = isSuccess ? 'Success' : 'Alert';
  const btnClass = isSuccess ? 'gam-btn gam-btn-success' : 'gam-btn gam-btn-warning';

  return (
    <div className="gam-overlay">
      <div className="gam-card animate-pop">
        <div className="gam-icon">{icon}</div>
        <h3 className="gam-title">{title}</h3>
        <p className="gam-message">{message}</p>
        <button className={btnClass} onClick={() => setIsOpen(false)}>OK</button>
      </div>
    </div>
  );
}
